module.exports = __webpack_public_path__ + "img/placeholder.685b76b3.png";